import { render, staticRenderFns } from "./PxSelects.vue?vue&type=template&id=36e68fbf&"
import script from "./PxSelects.vue?vue&type=script&lang=js&"
export * from "./PxSelects.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports